var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#CCA400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2511 14.4759C10.7191 14.4759 10.2571 14.3873 9.86506 14.2099C9.47306 14.0326 9.16972 13.7806 8.95506 13.4539C8.74039 13.1179 8.63306 12.7306 8.63306 12.2919C8.63306 11.8719 8.72639 11.4986 8.91306 11.1719C9.09972 10.8359 9.38906 10.5559 9.78106 10.3319C10.1731 10.1079 10.6677 9.94926 11.2651 9.85593L13.7571 9.44993V10.8499L11.6151 11.2139C11.2511 11.2793 10.9804 11.3959 10.8031 11.5639C10.6257 11.7319 10.5371 11.9513 10.5371 12.2219C10.5371 12.4833 10.6351 12.6933 10.8311 12.8519C11.0364 13.0013 11.2884 13.0759 11.5871 13.0759C11.9697 13.0759 12.3057 12.9966 12.5951 12.8379C12.8937 12.6699 13.1224 12.4413 13.2811 12.1519C13.4491 11.8626 13.5331 11.5453 13.5331 11.1999V9.23993C13.5331 8.91326 13.4024 8.64259 13.1411 8.42793C12.8891 8.20393 12.5531 8.09193 12.1331 8.09193C11.7411 8.09193 11.3911 8.19926 11.0831 8.41393C10.7844 8.61926 10.5651 8.89459 10.4251 9.23993L8.92706 8.51193C9.07639 8.11059 9.30972 7.76526 9.62706 7.47593C9.95372 7.17726 10.3364 6.94393 10.7751 6.77593C11.2137 6.60793 11.6897 6.52393 12.2031 6.52393C12.8284 6.52393 13.3791 6.64059 13.8551 6.87393C14.3311 7.09793 14.6997 7.41526 14.9611 7.82593C15.2317 8.22726 15.3671 8.69859 15.3671 9.23993V14.3079H13.6311V13.0059L14.0231 12.9779C13.8271 13.3046 13.5937 13.5799 13.3231 13.8039C13.0524 14.0186 12.7444 14.1866 12.3991 14.3079C12.0537 14.4199 11.6711 14.4759 11.2511 14.4759Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9761,
    width: 8,
    height: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongSound);
export default __webpack_public_path__ + "static/media/wrong-sound.a4060bf30a2a8279ba2308df6d78e7a5.svg";
export { ForwardRef as ReactComponent };